export default "__VITE_ASSET__DLVxfxTf__"